import { render, staticRenderFns } from "./FromBinLocation.vue?vue&type=template&id=38fa47a0&scoped=true&"
import script from "./FromBinLocation.vue?vue&type=script&lang=js&"
export * from "./FromBinLocation.vue?vue&type=script&lang=js&"
import style0 from "./FromBinLocation.vue?vue&type=style&index=0&id=38fa47a0&prod&lang=scss&"
import style1 from "./FromBinLocation.vue?vue&type=style&index=1&id=38fa47a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fa47a0",
  null
  
)

export default component.exports